<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>故障库</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchData.product" placeholder="请选择产品">
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.lang" placeholder="请选择语言">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button button2 add" @click="$router.push({name: 'psc-malfunction-update'})" v-if="roleCheck('103-103-103-102')">
                            <span>编辑</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="tableData">
                <el-table-column label="产品" prop="product">
                    <template >
                        <span>{{ searchData.product }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="语言">
                    <template>
                        <span>{{ appData.lang[searchData.lang] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="故障类型" prop="title"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import aliOss from '../../../aliOss/index'
export default({
    name: 'psc-malfunction',
    data() {
        return {
            faqShow: false,
            searchData: {
                product: 'M1',
                lang: 'zh',
                type: ''
            },
            mConfig: '',
            tableData: []
        }
    },
    watch: {
    },
    created() {
        this.getConfig();
    },
    methods: {
        getConfig() {
            aliOss.getFile('config.json').then(r => {
                this.mConfig = JSON.parse(r.content);
                console.log(this.mConfig)
                this.convertedTableData();
            })
        },
        search() {
            this.getConfig();
        },
        convertedTableData() {
            if(this.mConfig[this.searchData.product] && this.mConfig[this.searchData.product][this.searchData.lang] && this.mConfig[this.searchData.product][this.searchData.lang].malfunction) {
                const convertedData = this.mConfig[this.searchData.product][this.searchData.lang].malfunction;
                // const mArray = [];
                // for (const category in convertedData) {
                //     for (const item of convertedData[category]) {
                //         const product = this.searchData.product;
                //         const lang = this.searchData.lang;
                //         const type = category;
                //         const q = item.q;
                //         const a = item.a;
                //         mArray.push({ product, lang, type, q, a });
                //     }
                // }
                this.tableData = convertedData;
            }else{
                this.tableData = [];
            }
            
        }
    }
})
</script>
<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/view/app/product-service-center/malfunction.vue